<template>
    <article class="unsupported-card">
        <i class="fal fa-puzzle-piece"></i>
        <div class="unsupported-card-body">
            <span class="unsupported-card-title">{{ meta.label || meta.id }}</span>
            <span class="unsupported-card-desc">{{ message }}</span>
        </div>
    </article>
</template>

<script>
export default {
    name: 'UnsupportedWidget',
    props: {
        meta: { type: Object, required: true },
        value: { default: null }
    },
    computed: {
        message() {
            const display = this.meta && this.meta.display
            if (!display) {
                return this.$t('statistics.dashboard.unsupported_no_display')
            }
            return this.$t('statistics.dashboard.unsupported_display', { display })
        }
    }
}
</script>

<style scoped>
.unsupported-card {
    background: var(--v2-surface-1);
    border: 1px dashed var(--v2-border);
    border-radius: var(--v2-radius-lg);
    padding: 18px 20px;
    display: flex;
    align-items: center;
    gap: 14px;
    color: var(--v2-text-3);
    min-height: 120px;
}

.unsupported-card i {
    font-size: 1.4rem;
    color: var(--v2-text-4);
}

.unsupported-card-body {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.unsupported-card-title {
    font-size: 0.85rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-2);
}

.unsupported-card-desc {
    font-size: 0.78rem;
    color: var(--v2-text-4);
}
</style>
